export default __webpack_public_path__ + "static/media/Warring.46cbb8e5.svg";